<template>
  <div class="wrapper">
    <dvBtn
      :href="link.href"
      :title="link.title"
      v-for="(link, i) in linksLeft"
      :key="i"
      :target="'tab' + i"
    ></dvBtn>
    <div class="title">{{ title }}</div>
    <dvBtn
      :href="link.href"
      v-for="(link, i) in linksRight"
      :title="link.title"
      :key="i"
      :target="'tab' + i"
    ></dvBtn>
  </div>
</template>
<script>
import dvBtn from "./dvBtn";
export default {
  components: { dvBtn },
  props: {
    title: {
      type: String,
      default: "东邵渠大屏",
    },
    links: {
      type: Array,
      default: () => [
        {
          title: "标准化大屏",
          href: "",
          btntype: "success",
        },
        {
          title: "投资管理监测",
          href: "",
          btntype: "danger",
        },
        {
          title: "MES系统",
          href: "https://test.jumh.cn:8083/saas/#/loginApp",
          btntype: "success",
        },
        {
          title: "区域园区企业监测",
          href: "",
          btntype: "primary",
        },
      ],
    },
  },
  computed: {
    linksLeft() {
      if (this.links.length == 0) return [];
      let index = Math.ceil(this.links.length / 2);
      let links = this.links.slice(0, index);
      return links;
    },
    linksRight() {
      if (this.links.length == 0) return [];
      let index = Math.ceil(this.links.length / 2);
      let links = this.links.slice(index);
      return links;
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 10vh !important;
  display: flex !important;
  justify-content: space-evenly !important;
  align-items: center;
  z-index: 20;
  border-bottom: 2px solid #aaa;
  background: #00093c;
  filter: none;
  .title {
    color: white;
    filter: none;
    font-size: 34px;
    font-weight: bold;
    background: linear-gradient(to right, #409eff, #00f260);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    margin: 0 8vw;
  }
}
.text_a {
  color: #fff;
  text-decoration: none;
}
</style>
